import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@ps-design-system/components/Button';
import { Text } from '@ps-design-system/components/Text';

const UploadMediaCardWeb = ({ startIcon, heading, body, helperText, buttonLabel, onClick, attributes }) => {
  return (
    <div className='uploader-media-card tw-border tw-border-gray-400'>
      <div className='title-container'>
        <div>
          {startIcon}
        </div>
        <div>
          <Text typeface="headline-2-m">{heading}</Text>
        </div>
      </div>
      <Text typeface="body-2">{body}</Text>
      <Text className='tw-text-gray-600' typeface="body-1">{helperText}</Text>
      <Button
        appearance="black"
        onClick={onClick}
        attributes={attributes}
      >
        {buttonLabel}
      </Button>
    </div>
  );
};

UploadMediaCardWeb.propTypes = {
  startIcon: PropTypes.node,
  heading: PropTypes.node,
  body: PropTypes.node,
  helperText: PropTypes.node,
  buttonLabel: PropTypes.node,
  onClick: PropTypes.func,
  attributes: PropTypes.object
};

UploadMediaCardWeb.defaultProps = {
  startIcon: null,
  heading: null,
  body: null,
  helperText: null,
  buttonLabel: null,
  onClick: () => {},
  attributes: {}
};

export default UploadMediaCardWeb;
